import { createClient } from '@supabase/supabase-js'

// Read Supabase credentials from Vite env
// Vite provides import.meta.env types via vite/client in tsconfig types
const supabaseUrl = (import.meta as any).env.VITE_SUPABASE_URL as string | undefined
const supabaseAnonKey = (import.meta as any).env.VITE_SUPABASE_ANON_KEY as string | undefined

if (!supabaseUrl || !supabaseAnonKey) {
  // We avoid throwing to keep local dev workable; consumers should handle unauthenticated state
  // eslint-disable-next-line no-console
  console.warn('[Supabase] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY is not set')
}

export const supabase = createClient(supabaseUrl ?? '', supabaseAnonKey ?? '')

export type AppRole = 'ADMIN' | 'ADVISOR' | 'CLIENT' | 'PROSPECT'

export interface ProfileRow {
  id: string
  email: string | null
  full_name: string | null
  role: AppRole | null
  advisor_id: string | null
  org_id: string | null
  created_at?: string
  updated_at?: string
}


